/* Bored George - make backing out of the bundle page's personalise panel keep
   the bundle.

   The panel on the bundle builder is drawn and driven by bundle-builder.js.
   Its X and its backdrop (both [data-bgp-close]) only hide it, so a shopper
   who had built a two-pair bundle, pressed Add to cart and then closed the
   panel ended up with an EMPTY cart - measured, $302.40 lost. Escape did the
   same. That is the same bug that was fixed inside personalise-pdp.js and
   personalise-quick-add.js; those two files own their panels, so the fix went
   in directly. This one does not, and bundle-builder.js is the 29KB
   cart-facing script that is deliberately never rewritten - the risk of
   retyping it outweighs the change. So the close intent is intercepted here
   instead and turned into a press of the panel's own Skip button, which
   bundle-builder.js already implements correctly: bundle in, no cases.

   Deliberately conservative:

     - It only ever fires when the panel is open AND a Skip button is present.
       If a future version of the panel drops Skip, this file does nothing and
       the old close behaviour returns rather than something worse.
     - stopImmediatePropagation keeps bundle-builder.js's own close handler
       from also running, so there is no race between closing and adding.
     - A short lock stops a double-tap on the X from firing two adds, since
       the add is asynchronous and the panel stays up until it lands.

   Scoped by [data-bgp], which is the bundle panel only. The product page
   panel is [data-bgpdp] and the quick-add panel is [data-bgqa-panel]; neither
   matches, and both handle their own dismissal. */
(function () {
  'use strict';

  var lockedUntil = 0;

  function openPanel() {
    var p = document.querySelector('[data-bgp]');
    return p && !p.hidden ? p : null;
  }

  /* Returns true if the close intent was handled. */
  function skipInstead(panel) {
    var btn = panel.querySelector('[data-bgp-skip]');
    if (!btn || btn.disabled) return false;

    var now = (window.performance && performance.now) ? performance.now() : +new Date();
    if (now < lockedUntil) return true; /* swallow the repeat, add nothing */
    lockedUntil = now + 2000;

    btn.click();
    return true;
  }

  document.addEventListener('click', function (e) {
    var panel = openPanel();
    if (!panel) return;

    var hit = e.target.closest('[data-bgp-close]');
    if (!hit || !panel.contains(hit)) return;

    if (!skipInstead(panel)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    var panel = openPanel();
    if (!panel) return;

    if (!skipInstead(panel)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
})();
